export function useTimeGenerator(format) {

        let interval = 30; //minutes interval
        let times = []; // time array
        let startTime = 0; // start time
        let amPm = ['AM', 'PM']; // AM-PM

        //loop to increment the time and push results in array
        for (let i = 0; startTime < 24*60; i++) {
            let hours = Math.floor(startTime/60); // getting hours of day in 0-24 format
            let minutes = (startTime % 60); // getting minutes of the hour in 0-55 format

            // pushing data in array in [0:00 - 12:00 AM/PM format]
            if(format === 12)times[i] = ("" + (hours % 12)).slice(-2) + ':' + ("0" + minutes).slice(-2) + amPm[Math.floor(hours/12)];
            // startTime = startTime + interval;

            // 24 Hr Format
            if(format == 24)times[i] = {id: i, value: ("0" + (hours % 24)).slice(-2) + ':' + ("0" + minutes).slice(-2)};
            startTime = startTime + interval;
        }

        return times;

}
